"use client";

import { cn } from "@/lib/utils";
import { useCarousel } from "@ui/carousel";
import { Play } from "lucide-react";
import Image from "next/image";
import { ComponentProps } from "react";
import { ProductMedia } from "../types";

type ProductGalleryThumbnailProps = {
  media: ProductMedia;
  index: number;
} & ComponentProps<"button">;

export default function ProductGalleryThumbnail({
  media,
  index,
  className,
  ...props
}: ProductGalleryThumbnailProps) {
  const { scrollTo, selectedIndex } = useCarousel();
  const selected = index === selectedIndex;
  return (
    <button
      className={cn(
        "relative aspect-square shrink-0 border bg-gray-100 opacity-70 transition-[opacity,border] duration-150 ease-out hover:opacity-100 max-lg:h-full lg:w-full",
        selected && "border-black opacity-100",
        className,
      )}
      onClick={() => scrollTo(index)}
      {...props}
    >
      {media.type === "video" ? (
        <div className="relative h-full w-full">
          <video
            src={media.src}
            className="aspect-square h-full w-full bg-white object-cover"
            muted
            playsInline
            preload="metadata"
          />
          <Play className="absolute top-1/2 left-1/2 size-5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-black/70 fill-white p-1" />
        </div>
      ) : (
        <Image
          src={media.src}
          alt={media.alt}
          width={1000}
          height={1000}
          sizes="48px"
          fetchPriority="low"
          className="h-full w-full mix-blend-multiply"
        />
      )}
      <span className="sr-only">{index + 1}</span>
    </button>
  );
}
